export default __webpack_public_path__ + "static/media/overview.01dec87d.svg";